<div class="fixed inset-0 z-[9999] flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-slate-950/60 backdrop-blur-md animate-fade-in" (click)="onClose()"></div>
  <div
    class="relative bg-white dark:bg-slate-900 rounded-[32px] shadow-2xl w-full max-w-sm p-8 text-center animate-scale-up border border-white/20 dark:border-slate-800/50"
    (click)="$event.stopPropagation()">
    <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full mb-6 shadow-inner"
      [ngClass]="{
        'bg-amber-50 dark:bg-amber-900/30': variant === 'warning',
        'bg-rose-50 dark:bg-rose-900/30': variant === 'error',
        'bg-sky-50 dark:bg-sky-900/30': variant === 'info'
      }">
      <span class="material-icons-outlined text-4xl"
        [ngClass]="{
          'text-amber-500': variant === 'warning',
          'text-rose-500': variant === 'error',
          'text-sky-500': variant === 'info'
        }">{{ resolvedIcon }}</span>
    </div>

    <h3 class="text-xl font-black text-slate-800 dark:text-white mb-2 tracking-tight">{{ title }}</h3>

    <p class="text-sm text-slate-500 dark:text-slate-400 mb-8 leading-relaxed whitespace-pre-line">
      {{ message }}
    </p>

    <button type="button" (click)="onClose()"
      class="w-full py-3 text-white rounded-xl text-sm font-bold shadow-lg active:scale-95 transition-all border-none cursor-pointer"
      [ngClass]="{
        'bg-amber-500 hover:bg-amber-600 shadow-amber-500/20': variant === 'warning',
        'bg-rose-600 hover:bg-rose-700 shadow-rose-600/20': variant === 'error',
        'bg-sky-500 hover:bg-sky-600 shadow-sky-500/20': variant === 'info'
      }">
      {{ confirmLabel }}
    </button>
  </div>
</div>
